import {
  dimensionByQuizId,
  DimensionByQuizIdRequestParams,
} from "@/requests/questionnaries/dimension-by-quiz-id.request";
import { useQuery } from "@tanstack/react-query";

export const buildDimensionByQuizIdQueryKey = (
  params: DimensionByQuizIdRequestParams,
) => [
  "companies",
  params.companyId,
  "quiz",
  params.applicationQuizId,
  "dimension",
  params.dimension,
];

export const useDimensionByQuizId = (
  params: DimensionByQuizIdRequestParams,
) => {
  return useQuery({
    queryKey: buildDimensionByQuizIdQueryKey(params),
    queryFn: () => dimensionByQuizId(params),
    enabled: Object.values(params).every(Boolean),
  });
};
